<template>
    <div style="height:100% ;"  v-show="showBlank">
        <div  :class="showAttachment || showAddLink ? 'popover_filter1' : 'popover_filter'" >
            <div class="training-filter__arrow-up"></div>

            <div class="popover_filter__header">
              <h4 v-if="showAddLink">Enter/Paste link below </h4>
              <h4 v-if="showAttachment">Add Attachments </h4>
            </div>
            <div class="popover_filter__body">
                <div>
                    <div class="row">
                        <div class="col-md-12" style="padding-bottom:15px;">
                             <template v-if="showAddLink">
                                <div class="row">
                                    <div class="col-md-12">
                                         <div class="form-group col-md-12">
                                            <ob-input v-model.trim="Link" placeholder="Enter/Paste any link here..." ></ob-input>
                                            <span class="ob-vuelidate_error-msg" style="padding-left: 5px" 
                                                v-if="isLinkErrorMessage" >{{errorMessageLink}} </span>
                                        </div>
                                         <div class="col-md-12" style="text-align: center;">
                                            <ob-button type="primary" :disabled="Link == ''" @click="onSaveLink()">Save</ob-button>
                                           <ob-button  type="secondary" @click="showAddLink = false ; showAttachment = false ; isLinkErrorMessage = false " >Cancel</ob-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="showAttachment">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="col-md-12">
                                    <ob-upload-attachment :key="iCounter" ref="upload" @error-msg="IsInvalidFile" @file-inProgress="InProgress" @file-complete="onuploadComplete" @closePopup="onCancel" :validation="ValidationType" :end-point="EndPoint" :type="1" :IsFileExists="filename" :attach-file.sync="attachFile">
                                      <template slot="file-text">
                                          <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                                      </template>
                                    </ob-upload-attachment>
                                      <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                v-if="isErrorMessageDisabled && $refs.upload.Errors.length==0" >{{errorMessageFrmResponse}} </span>
                                  </div>
                                </div>
                                <div class="col-md-12" style="text-align: center;">
                                  <!-- <ob-button type="primary" :disabled="disableSaveAttachment" @click="onSaveAttachments()">Save</ob-button>
                                  <ob-button  type="secondary" @click="showAddLink = false ; showAttachment = false" >Cancel</ob-button>  -->
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="row">
                                <div class="col-md-12">
                                  <span id="computer" class="link-styles"  @click="open()" >
                                    Upload from computer
                                  </span><span><span v-tooltip.top="'We accept either pdf, xls, xlsx, doc, docx, zip, images upto 25MB.'"><i class="fa fa-info-circle" aria-hidden="true"></i></span> </span>  <br>
                                  <br>
                                  <span  id="past"  class="link-styles"  @click="showAddLink = true ; showAttachment = false ;" style="margin-top:5px;">
                                    Enter/Paste link here <i class="fa fa-chevron-right" aria-hidden="true" style="font-size: 10px;"></i>
                                  </span>
                                </div>
                              </div>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import c from 'Vue/Core/constants.js'
    export default{
        data(){
            return{
                  showBlank:true,
                  showAddLink:false,
                  showAttachment:false,
                  Link:'',
                  errorMessageFrmResponse:'',
                  isErrorMessageDisabled: false,
                  isLinkErrorMessage: false,
                  errorMessageLink:'',
                  iCounter:0,
                  Attachments:[],
                  disableSaveAttachment:true,
                  ValidationType:{
                    Rules: {
                        Type: ["pdf", "zip", "xls", "xlsx", "doc", "docx", "png", "gif", "jpg", "jpeg"],
                        Size: 26214400, // In Bytes
                        multiplefiles:true
                    },
                    Messages: {
                        Type: "Please upload valid file formats",
                        Size: `Please upload a file which is less than 25MB`,
                    },
                    excludeList:false
                },
                filename:[],
                EndPoint: `${c.APIBASEURL}/File/FileUpload`,
                attachFile:false,
                }
        },
        methods:{
            onCancel(){
                this.$emit('closePopup')
            },
            onSaveAttachments()
            {
               if(this.Attachments.length > 0)
               {
                  this.$parent.addAttachment(this.Attachments)
               }
            },
            validateUrl(url) {
             var regexQuery = /^(http|https|)\:\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
              if (regexQuery.test(url))
              {
                return true
              }
              return false
            
            },
            onSaveLink()
            {
                let linkurl = this.Link  
                var url = this.validateUrl(linkurl)
                if(!url)
                {
                    this.isLinkErrorMessage = true
                    this.errorMessageLink = "Please enter valid url 'Ex: https://example.com'"; 
                }
                else{
                    this.isLinkErrorMessage = false
                    this.$parent.addAttachment(this.Link)
                    
                }
                
               
            },
            InProgress()
            {
              this.showBlank = true
            },
            IsInvalidFile(error)
            {
            if(error != '')
            {
                this.$message({
                type: 'error',
                message: error
                });
            }
            },
            open() {
                this.showAttachment = true ; this.showAddLink = false;  this.showBlank = false
                setTimeout(() => {
                     this.disableSaveAttachment = true
                    this.$refs.upload.uploadNew();
                    //this.attachFile = true
                }, 1000)
            },
             onuploadComplete(v) {
               for(var i=0 ; i<v.length ; i++)
               {
                   if (v[i].response.Url != null)
                    this.Attachments.push(v[i].response.Url)
                    this.disableSaveAttachment = false
               }
              if(this.Attachments.length > 0)
                {
                  this.$parent.addAttachment(this.Attachments)
                  this.isErrorMessageDisabled=false
                }
                if (v[0].response.State==false && v[0].response.Message!=null)
                {
                this.iCounter++
                this.isErrorMessageDisabled=true
                this.errorMessageFrmResponse=v[0].response.Message
                }
             },
        },

    }
</script>
<style lang="scss" scoped>
    @import "~styles/framework/bootstrap/variables";

    .link-styles{
      font-weight: 600;
      font-size: 12px;
        cursor: pointer;
          &:hover,
        &:active,
        &:focus {
          color: #4A90E2;
          text-decoration: underline !important;
      }
    }

    .popover_filter{
        background: $ob-white-color;
        position: relative;
        border: 1px solid $ob-light-gray-1;
        border-radius: 4px;
        -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
        -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
        box-shadow: 0 2px 4px 0 $ob-filter-grey;
        position: absolute;
        top: 53px;
        right: 75px;
        z-index: 4;
        &:after, &:before{
            bottom: 100%;
            left: 70%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        &:before {
            border-color: transparent;
            border-bottom-color: $ob-light-gray-1;
            border-width: 13px;
            margin-left: -13px;
        }
        &:after {
            border-color: rgba(255, 255, 255, 0);
            border-bottom-color: $ob-white-color;
            border-width: 12px;
            margin-left: -12px;
        }
        p{
            margin-bottom: 0;
        }
        h4 {
            color: $ob-brand-primary;
        }
        .popover_filter__header {

            padding: 10px;
        }
        .popover_filter__body {
            background: $ob-white-color;
            padding: 15px;
            max-height: 300px;
                .form-group{
                label{
                    display: inline-block;
                    max-width: 100%;
                    margin-bottom: 5px;
                    font-weight: 400;
                }
            }
        }
        .popover_filter__footer {
            text-align: center;
            background: $ob-white-color;
            margin: 0;

            padding: 10px;
            button{
                margin: 0 5px;
            }
        }
    }
      .popover_filter1{
        width : 104%;
         background: $ob-white-color;
        position: relative;
        border: 1px solid $ob-light-gray-1;
        border-radius: 4px;
        -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
        -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
        box-shadow: 0 2px 4px 0 $ob-filter-grey;
        position: absolute;
        top: 53px;
        right: 0px;
        z-index: 4;
        &:after, &:before{
            bottom: 100%;
            left: 70%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        &:before {
            border-color: transparent;
            border-bottom-color: $ob-light-gray-1;
            border-width: 13px;
            margin-left: -13px;
        }
        &:after {
            border-color: rgba(255, 255, 255, 0);
            border-bottom-color: $ob-white-color;
            border-width: 12px;
            margin-left: -12px;
        }
        p{
            margin-bottom: 0;
        }
        h4 {
            color: $ob-brand-primary;
        }
        .popover_filter__header {

            padding: 10px;
        }
        .popover_filter__body {
            background: $ob-white-color;
            max-height: 300px;
                .form-group{
                label{
                    display: inline-block;
                    max-width: 100%;
                    margin-bottom: 5px;
                    font-weight: 400;
                }
            }
        }
        .popover_filter__footer {
            text-align: center;
            background: $ob-white-color;
            margin: 0;

            padding: 10px;
            button{
                margin: 0 5px;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/AddFromComputer.vue